<template>
  <div
    v-if="days"
    class="kanban"
  >
    <Day
      v-for="day in days"
      :key="day.format('YYYY-MM-DD')"
      ref="dragula"
      :day="day"
      :data="dataForDay(day)"
      @saved="$emit('saved', $event)"
      @deleted="onDeleted"
    />
  </div>
  <div v-else>
    Keine Tage ausgewählt.
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import Day from './Day'

import dragula from '../../../node_modules/dragula/dragula'

var data = {
  'copy': false,
  drake: undefined
}

var createDragula = function (self) {
  if (!self.$refs.dragula) {
    return null
  }
  return dragula(self.$refs.dragula.map(x => x.$el.childNodes[2]), {
    revertOnSpill: true,
    isContainer: (el) => false,
    moves: (el, source, handle, sibling) => {
      if (handle.classList.contains('move')) {
        self.$data.copy = false
      } else if (handle.classList.contains('copy')) {
        self.$data.copy = true
      }
      return handle.classList.contains('move') || handle.classList.contains('copy')
    },
    accepts: (el, target, source, sibling) => source !== target,
    invalid: (el, handle) => false,
    copy: (el, source) => {
      if (self.$data.copy) {
        self.$data.log = el.__vue__.log
        return true
      } else {
        return false
      }
    }
  }).on('drop', (el, target, source, sibling) => {
    const day = target.offsetParent.__vue__.day.format('YYYY-MM-DD')
    if (self.$data.copy) {
      var log = self.$data.log
      var newLog = {
        'description': log.description,
        'employee': log.employee,
        'journey': log.journey,
        'operation': log.operation,
        'place': log.place,
        'taskday': day,
        'taskduration': log.taskduration,
        'project': log.project
      }
      self.$drfapi.postObject(
        'logs',
        newLog
      )
    } else {
      var movedLog = el.__vue__.log
      const obj = {
        id: movedLog.id,
        taskday: day
      }
      self.$drfapi.patchObject(
        'logs',
        obj
      )
    }
    el.remove()
  })
}

export default {
  name: 'Kanban',
  components: {
    Day,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    days () {
      return this.daysInSelectedPeriod.slice(0, 31)
    },
    dataForDay () {
      const data = this.data
      return (day) => {
        if (data !== null) {
          return data.filter(i => moment(i.taskday).isSame(day))
        } else {
          return []
        }
      }
    },
    ...mapGetters(['daysInSelectedPeriod']),
  },
  data: function () {
    return data
  },
  mounted () {
    this.drake = createDragula(this)
  },
  updated () {
    if (this.drake) {
      this.drake.destroy()
      this.drake = null
    }
    this.drake = createDragula(this)
  },
  methods: {
    onDeleted (log) {
      this.$emit('deleted', log)
    },
  },
}
</script>

<style lang="scss" scoped>
.kanban {
  display: inline-flex;
  justify-content: flex-start;
  flex-direction: row;
  flex-basis: 0;
  flex-wrap: nowrap;
  overflow-x: auto;
  padding-bottom: 17px;
  width: 100%;
  margin: 10px 0 0 0;

  @media screen and (max-width: 1200px) {
    display: block;
  }

  div {
    position: relative;
    flex-direction: column;
    flex-grow: 1;
    flex-basis: 0;
    margin: 0 3px 0 3px;

    @media screen and (min-width: 1200px) {
      &:first-child {
        margin: 0 3px 0 0;
      }

      &:last-child {
        margin: 0 0 0 3px
      }
    }

    @media screen and (max-width: 1200px) {
      margin-bottom: 5px;
      min-height: 30px;
    }
  }
}
</style>
